import { type RouteObject } from 'react-router';
import { RoutesList } from '../../config/routes-list';
import MainLayout from '../../layouts/MainLayout';
import { MenuAddonGuard } from '../guards/menu-addon.guard';
import { lazyRoute, lazyRouteNamed } from '../lazy-route';

const suppliersPageRoute = lazyRouteNamed(
  () => import('../../pages/suppliers/SuppliersPage'),
  'SuppliersPage',
);
const recipesListRoute = lazyRoute(() => import('../../pages/recipes/main-page'));
const recipeDetailRoute = lazyRouteNamed(
  () => import('../../pages/recipes/recipe-detail-page'),
  'RecipeDetailPage',
);
const ingredientsPageRoute = lazyRoute(() => import('../../pages/ingredients/main-page'));
const menusListRoute = lazyRoute(() => import('../../pages/menus/components/menus-page'));
const menuDetailRoute = lazyRoute(() => import('../../pages/menus/components/menu-detail-page'));

export const warehouseRoutes: RouteObject[] = [
  {
    path: RoutesList.SUPPLIERS,
    element: <MainLayout />,
    children: [
      { index: true, ...suppliersPageRoute },
      { path: 'new', ...suppliersPageRoute },
      { path: ':id/edit', ...suppliersPageRoute },
    ],
  },
  {
    path: RoutesList.LOTS,
    element: <MainLayout />,
    children: [
      { index: true, ...lazyRouteNamed(() => import('../../pages/lots/main-page'), 'LotsPage') },
      {
        path: 'create-from-recipe/:recipeId',
        ...lazyRouteNamed(
          () => import('../../pages/lots/create-from-recipe-page'),
          'CreateFromRecipePage',
        ),
      },
      {
        path: ':id',
        ...lazyRouteNamed(() => import('../../pages/lots/detail-page'), 'LotDetailPage'),
      },
      {
        path: ':id/prepackaged-label',
        ...lazyRouteNamed(() => import('../../pages/lots/detail-page'), 'LotDetailPage'),
      },
    ],
  },
  {
    path: RoutesList.RECIPES,
    element: <MainLayout />,
    children: [
      { index: true, ...recipesListRoute },
      { path: 'new', ...recipesListRoute },
      { path: ':id/edit', ...recipeDetailRoute },
      { path: ':id/ingredient/:ingredientId/edit', ...recipeDetailRoute },
      { path: ':id', ...recipeDetailRoute },
    ],
  },
  {
    path: RoutesList.INGREDIENTS,
    element: <MainLayout />,
    children: [
      { index: true, ...ingredientsPageRoute },
      { path: 'new', ...ingredientsPageRoute },
      { path: ':id/edit', ...ingredientsPageRoute },
      { path: ':id/edit/:tab', ...ingredientsPageRoute },
    ],
  },
  {
    path: RoutesList.PRODUCTION,
    element: <MainLayout />,
    children: [
      {
        index: true,
        ...lazyRouteNamed(() => import('../../pages/production/main-page'), 'ProductionPage'),
      },
    ],
  },
  {
    path: RoutesList.RECALLS,
    element: <MainLayout />,
    children: [
      {
        index: true,
        ...lazyRouteNamed(() => import('../../pages/recalls/main-page'), 'RecallsPage'),
      },
      {
        path: 'new',
        ...lazyRouteNamed(() => import('../../pages/recalls/new-page'), 'RecallNewPage'),
      },
      {
        path: ':id',
        ...lazyRouteNamed(() => import('../../pages/recalls/detail-page'), 'RecallDetailPage'),
      },
    ],
  },
  {
    path: RoutesList.MENUS,
    element: <MenuAddonGuard />,
    children: [
      {
        path: '',
        element: <MainLayout />,
        children: [
          { index: true, ...menusListRoute },
          { path: 'new', ...menusListRoute },
          { path: ':id/edit', ...menuDetailRoute },
          { path: ':id', ...menuDetailRoute },
        ],
      },
    ],
  },
];
